import { withStyles, withTheme } from '@material-ui/core';
import React from 'react';
import { compose } from 'recompose';
import appConstants from '../../../../appConstants';
import { UnacknowledgedMarker } from '../../../mapComponents/Markers';
import { isPickupStopUnAcknowledged } from './genericCellRenderer';
import StyledToolTip from '../../../common/StyledToolTip';
import ClosingSoonBadge from '../../../modules/Dispatch/Common/ClosingSoonBadge';

const styles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  iconStyle: {
    marginLeft: 5
  }
});

const StopTypeRenderer = (props) => {
  const { classes, data, theme, context } = props;
  return (
    <div className={classes.container}>
      <div>{data.stopType === appConstants.STOP_TYPE.Pickup ? 'P' : 'D'}</div>

      {isPickupStopUnAcknowledged(data) ? (
        <div className={classes.iconStyle}>
          <StyledToolTip title="Unacknowledged Pickup">
            <div>
              <UnacknowledgedMarker
                size={18}
                backgroundColor={theme.pickupStatusFillColors}
                borderColor={theme.markerStokeColor}
              />
            </div>
          </StyledToolTip>
        </div>
      ) : null}
      {data.stopType === appConstants.STOP_TYPE.Pickup && (
        <ClosingSoonBadge
          timeToCloseInMins={context.getClosingSoonPickupTime(data.pickupId)}
          closingSoonLimitConfig={context.closingSoonLimitConfig}
        />
      )}
    </div>
  );
};

export default compose(withTheme(), withStyles(styles))(StopTypeRenderer);
